module.exports = __webpack_public_path__ + "img/010李云龙.d20bfead.png";